# frozen_string_literal: true

module Engine
  module Game
    module G1894
    end
  end
end
